/* @flow */
import React from 'react';

import BoxBody from 'components/BoxBody.jsx';
import BoxHeader from 'components/BoxHeader.jsx';
import CurrentUser from 'auth/CurrentUser';
import Group from 'entities/Group';
import Image from 'components/Image.jsx';
import LinkConstants from 'constants/LinkConstants';
import SmsInstruction from 'users/components/SmsInstruction.jsx';
import TabPanel from 'components/TabPanel.jsx';

import './styles/InviteInClassInstructionsTab.scss';

class InviteInClassInstructionsTab extends React.Component {
  props: {
    group: Group,
    title: mixed,
  }

  isSmsEnabled(): boolean {
    return this.props.group.smsEnabledForUser(CurrentUser.getUser());
  }

  renderContent() {
    const { group } = this.props;
    if (this.isSmsEnabled()) {
      return (
        <SmsInstruction group={group} />
      );
    } else {
      const qrLink: string = LinkConstants.QR + '/?s=' + group.getJoinUrl();
      return (
        <div>
          <BoxHeader title="Ask your class to scan this QR code with their smartphones" />
          <BoxBody>
            <Image className="InviteInClassInstructionsTab-qrCode" src={qrLink} />
          </BoxBody>
        </div>
      );
    }
  }

  render() {
    const eventElementName = this.isSmsEnabled ?
      'tab-in-class-instructions' :
      'tab-in-class-instructions-no-sms';
    return (
      <TabPanel
        key="inclassPanel"
        selectedBorderColor="shamrock"
        className="InviteInClassInstructionsTab"
        eventElementName={eventElementName}
        title={this.props.title}>
        {this.renderContent()}
      </TabPanel>
    );
  }
}

export default InviteInClassInstructionsTab;



// WEBPACK FOOTER //
// ./src/groups/components/InviteInClassInstructionsTab.jsx